/* =====================
   Ajoutez ici votre propre javascript personnalisé
   ===================== */

/* BEGIN Ortho-Dynamic Google Ads lead tracking - 2026-10-11 */
(function () {
  var PHONE_SEND_TO = 'AW-16871373216/7gWvCIWsuqcaEKDz8uw-';
  var APPOINTMENT_SEND_TO = 'AW-16871373216/0GYnCIKsuqcaEKDz8uw-';
  function sendConversion(sendTo) {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', 'conversion', { send_to: sendTo, value: 1.0, currency: 'EUR' });
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    if (href.indexOf('tel:') === 0) sendConversion(PHONE_SEND_TO);
    else if (/doctolib\.fr/i.test(href)) sendConversion(APPOINTMENT_SEND_TO);
  });
  document.addEventListener('submit', function (event) {
    if (event.target && event.target.matches('#contact_form') && event.target.checkValidity()) {
      sendConversion(APPOINTMENT_SEND_TO);
    }
  }, true);
}());
/* END Ortho-Dynamic Google Ads lead tracking */